/**
 * Pure helper functions extracted from bid_form_controller.js
 */

export function validateBidAmount(amount, minimumBid) {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return { valid: false, errorMessage: `Minimum bid is $${minimumBid.toLocaleString()}` }
  }

  if (amount <= 0 || amount < minimumBid) {
    return { valid: false, errorMessage: `Minimum bid is $${minimumBid.toLocaleString()}` }
  }

  return { valid: true, errorMessage: null }
}

export function formatBidError(errors) {
  if (!errors || !Array.isArray(errors) || errors.length === 0) {
    return 'Failed to place bid'
  }
  return errors.join(', ')
}
